// Copyright (c) StrangeBee 2023

import { Space } from 'antd';
import React, { ReactElement, ReactNode } from 'react';
import OwnerIcon from '@Atoms/OwnerIcon/OwnerIcon';
import { IsFlag } from '@Organisms/IsFlag/IsFlag';
import { CaseOutput } from 'thehive-sdk';

interface CaseListChecboxCellProps {
    checkbox: ReactNode;
    data: CaseOutput;
    onFlagClick?: (value: boolean) => void;
    orgHasLinks?: boolean;
}

const CaseListCheckboxCell = ({
    checkbox,
    data,
    onFlagClick,
    orgHasLinks = false,
}: CaseListChecboxCellProps): ReactElement => {
    const { flag = false, extraData } = data;
    const { isOwner = false } = extraData || {};

    return (
        <Space direction="vertical" size={1}>
            {checkbox}

            <IsFlag value={flag} onClick={() => onFlagClick?.(flag)} />

            {orgHasLinks ? <OwnerIcon isOwner={isOwner} /> : null}
        </Space>
    );
};

export default CaseListCheckboxCell;
